import { render, staticRenderFns } from "./SizeInformationView.vue?vue&type=template&id=4c3c737c&"
import script from "./SizeInformationView.vue?vue&type=script&lang=js&"
export * from "./SizeInformationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports